import React, { useEffect, useState } from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const BackToTop = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 300);
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            style={{
                position: 'fixed',
                bottom: '32px',
                right: '32px',
                width: 'auto',
                height: '40px',
                padding: '0 16px',
                borderRadius: '20px',
                background: 'rgba(30,36,40,0.85)',
                border: '1px solid rgba(255,255,255,0.2)',
                color: 'white',
                fontSize: '13px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                zIndex: 999,
                opacity: visible ? 1 : 0,
                pointerEvents: visible ? 'auto' : 'none',
                transition: 'opacity 0.3s ease',
            }}
            aria-label="Back to top"
        >
            ↑ Back to Top
        </button>
    );
};

const LayoutDefault = ({children}) => (
    <>
        <Header navPosition="right" className="reveal-from-bottom"/>
        <main className="site-content">
            {children}
        </main>
        <Footer/>
        <BackToTop />
    </>
);

export default LayoutDefault;
